import { useQuery } from 'react-query';

import {
    QueryParams,
    QueryResponse,
    getShowPredictionLikelihoodForProject,
} from 'api/endPoints/getShowPredictionLikelihoodForProject';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetProjectIsShowPredictionLikelihood = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getIsShowPredictionLikelihoodForProject', params.projectId],
        queryFn: () => getShowPredictionLikelihoodForProject(params),
        enabled: Boolean(params.projectId),
    });
};
